import { create } from 'zustand';
import { api } from '../api/client';
import type { UserPrefs, LogViewerPrefs } from '../api/types';

interface PrefsState {
  prefs: UserPrefs;
  loaded: boolean;
  load: () => Promise<void>;
  updateLogViewer: (patch: Partial<LogViewerPrefs>) => void;
}

let saveTimer: ReturnType<typeof setTimeout> | null = null;
const debouncedSave = (prefs: UserPrefs) => {
  if (saveTimer) clearTimeout(saveTimer);
  saveTimer = setTimeout(() => {
    api.put('/api/users/me/preferences', prefs).catch(() => undefined);
  }, 500);
};

export const usePrefsStore = create<PrefsState>((set, get) => ({
  prefs: {},
  loaded: false,
  load: async () => {
    try {
      const { data } = await api.get<UserPrefs>('/api/users/me/preferences');
      set({ prefs: data || {}, loaded: true });
    } catch {
      set({ loaded: true });
    }
  },
  updateLogViewer: (patch) => {
    const next: UserPrefs = {
      ...get().prefs,
      logViewer: { ...(get().prefs.logViewer ?? {}), ...patch },
    };
    set({ prefs: next });
    debouncedSave(next);
  },
}));
